// Shared USB console Admin password from badge-firmware PR #70.
// Keep in sync with its operator UIs and main/hal/admin_auth.cpp verifier.
// This operator guard is separate from the station password and per-badge token.
export const BADGE_ADMIN_PASSWORD =
  "badge-admin-uFucxxuvN0etszXP7bHQ4hfCiO_StFOI";

export const redactBadgeAdminPassword = (text: string): string =>
  text.split(BADGE_ADMIN_PASSWORD).join("[hidden]");
